// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2d8a303e","453":"6ca15d09","667":"059dc58e","977":"44bcb71f"}[chunkId] + ".chunk.js";
};